import { useState } from "react";
import { useDocsLocalization } from "./use-docs-localization";

function getPageUrl() {
  return globalThis.location.href;
}

async function copyPageUrl() {
  await globalThis.navigator.clipboard.writeText(getPageUrl());
}

export function PageShareButtons() {
  const { messages } = useDocsLocalization();
  const [status, setStatus] = useState("");

  const handleCopy = async () => {
    try {
      await copyPageUrl();
      setStatus(messages.linkCopied);
    } catch {
      setStatus(messages.copyFailed);
    }
  };

  const handleGmailShare = () => {
    const subject = encodeURIComponent(messages.shareTitle);
    const body = encodeURIComponent(`${messages.shareText}\n\n${getPageUrl()}`);
    globalThis.open(
      `https://mail.google.com/mail/?view=cm&fs=1&su=${subject}&body=${body}`,
      "_blank",
      "noopener,noreferrer",
    );
  };

  const handleMoreSharingOptions = async () => {
    if (typeof globalThis.navigator.share !== "function") {
      try {
        await copyPageUrl();
        setStatus(messages.shareFallbackCopied);
      } catch {
        setStatus(messages.sharingUnavailable);
      }
      return;
    }

    try {
      await globalThis.navigator.share({
        title: messages.shareTitle,
        text: messages.shareText,
        url: getPageUrl(),
      });
      setStatus("");
    } catch (error) {
      if (error instanceof Error && error.name !== "AbortError") {
        setStatus(messages.sharingFailed);
      }
    }
  };

  return (
    <div className="kaleo-page-share" data-pagefind-ignore="all">
      <div className="kaleo-page-share-actions">
        <button type="button" onClick={handleCopy}>
          <svg aria-hidden="true" viewBox="0 0 24 24">
            <rect x="9" y="9" width="11" height="11" rx="2" />
            <path d="M15 9V6a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h3" />
          </svg>
          {messages.copyLink}
        </button>
        <button type="button" onClick={handleGmailShare}>
          <svg aria-hidden="true" viewBox="0 0 24 24">
            <rect x="3" y="5" width="18" height="14" rx="2" />
            <path d="m4 7 8 6 8-6" />
          </svg>
          {messages.shareViaGmail}
        </button>
        <button type="button" onClick={handleMoreSharingOptions}>
          <svg aria-hidden="true" viewBox="0 0 24 24">
            <circle cx="18" cy="5" r="2" />
            <circle cx="6" cy="12" r="2" />
            <circle cx="18" cy="19" r="2" />
            <path d="m8 11 8-5M8 13l8 5" />
          </svg>
          {messages.moreSharingOptions}
        </button>
      </div>
      <p className="kaleo-page-share-status" aria-live="polite">
        {status}
      </p>
    </div>
  );
}
